import Model from "../../model"
import { FleetingIdea, HexColor, IdeaType, Location, SourceType } from "../../types"
import * as Commands from "../index"

export const placeFleetingIdeaCommands = (
  model: Model,
  fleetingIdea: FleetingIdea,
  location: Location,
) => {
  const updatedAt = new Date()
  const c1 = new Commands.DeleteFleetingIdeaCommand({
    id: fleetingIdea.id,
  })
  const c2 = new Commands.CreateIdeaCommand({
    id: fleetingIdea.id,
    idea: {
      id: fleetingIdea.id,
      type: "idea" as IdeaType,
      colour: model.getNearest(location)?.colour || ("#55FF99" as HexColor),
      memo: "",
      title: "",
      content: fleetingIdea.content,
      location,
      sourceType: (fleetingIdea.sourceId ? "web" : null) as SourceType,
      sourceId: fleetingIdea.sourceId ? fleetingIdea.sourceId : null,
      connections: [],
      createdAt: fleetingIdea.createdAt,
      updatedAt,
      editedAt: fleetingIdea.createdAt,
      lastViewedAt: null,
    },
  })
  return [c1, c2]
}
